import { TranslateModule } from '@ngx-translate/core';
import {
  DayOfWeek,
  Frequency,
  Maybe,
  MonthlyRecurrenceConfigDay,
  MonthlyRecurrenceConfigType,
} from '@iss/libs/graphql';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';
import {
  KeyValuePipe,
  NgFor,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  SlicePipe,
} from '@angular/common';

import { DailyScheduleType, MonthlyScheduleType, RecurrenceScheduleControls } from '../recurrence-schedule.form-group';
import { RecurrenceScheduleFrequencyPipe } from '../recurrence-schedule-frequency.pipe';
import { RecurrenceScheduleDayPipe } from '../recurrence-schedule-day.pipe';
import { RecurrenceDayOfWeekPipe } from '../recurrence-day-of-week.pipe';
import { MonthlyRecurrenceTypePipe } from '../../../pipes/monthly-recurrence-type.pipe';

import { WeeklyRecurrenceComponent } from './weekly-recurrence';
import { MonthlyRecurrenceComponent } from './monthly-recurrence';
import { MonthlyNthRecurrenceComponent } from './monthly-nth-recurrence';
import { DailyRecurrenceComponent } from './daily-recurrence';

import { SelectComponent , SelectOptionDirective } from '@iss/core/select';
import { InclusiveButtonsComponent } from '@iss/core/inclusive-buttons';
import {
  InputDirective,
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  ControlStatusDirective,
} from '@iss/core/forms';
import { ExclusiveButtonsComponent } from '@iss/core/exclusive-buttons';

@Component({
  selector: 'wo-recurrence-schedule-configurator',
  templateUrl: './recurrence-schedule-configurator.component.html',
  styleUrls: [ './recurrence-schedule-configurator.component.scss' ],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormFieldComponent,
    LabelDirective,
    ExclusiveButtonsComponent,
    ControlStatusDirective,
    FormFieldErrorDirective,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    DailyRecurrenceComponent,
    InputDirective,
    WeeklyRecurrenceComponent,
    InclusiveButtonsComponent,
    MonthlyRecurrenceComponent,
    MonthlyNthRecurrenceComponent,
    SelectComponent,
    SelectOptionDirective,
    NgFor,
    SlicePipe,
    KeyValuePipe,
    TranslateModule,
    RecurrenceScheduleDayPipe,
    RecurrenceScheduleFrequencyPipe,
    MonthlyRecurrenceTypePipe,
    RecurrenceDayOfWeekPipe,
  ],
})
export class RecurrenceScheduleConfiguratorComponent {
  public readonly Frequency = Frequency;
  public readonly DailyScheduleType = DailyScheduleType;
  public readonly MonthlyScheduleType = MonthlyScheduleType;
  public readonly frequencies = [ Frequency.Daily, Frequency.Weekly, Frequency.Monthly ];
  public readonly daysOfWeek = [ DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday, DayOfWeek.Saturday, DayOfWeek.Sunday ];
  public readonly recurrenceDays = [ MonthlyRecurrenceConfigDay.Day,MonthlyRecurrenceConfigDay.Weekday,MonthlyRecurrenceConfigDay.WeekendDay, MonthlyRecurrenceConfigDay.Monday, MonthlyRecurrenceConfigDay.Tuesday, MonthlyRecurrenceConfigDay.Wednesday, MonthlyRecurrenceConfigDay.Thursday, MonthlyRecurrenceConfigDay.Friday, MonthlyRecurrenceConfigDay.Saturday, MonthlyRecurrenceConfigDay.Sunday ];
  public readonly monthlyTypes = [
    MonthlyRecurrenceConfigType.First,
    MonthlyRecurrenceConfigType.Second,
    MonthlyRecurrenceConfigType.Third,
    MonthlyRecurrenceConfigType.Fourth,
    MonthlyRecurrenceConfigType.Last,
  ];

  @Input({ alias: 'issFormGroup', required: true }) public formGroup!: FormGroup<RecurrenceScheduleControls>;
  @Input() public readonly: Maybe<boolean>;

  public onActivate(): boolean {
    return !this.readonly; // prevent to check radio button
  }
}
